import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface DataSourceCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  details: string[];
  className?: string;
}

export function DataSourceCard({ icon, title, description, details, className }: DataSourceCardProps) {
  return (
    <div
      className={cn(
        "group rounded-xl border bg-card p-6 transition-all hover:shadow-elevated hover:border-primary/20",
        className
      )}
    >
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
          {icon}
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-foreground mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground mb-3">{description}</p>
          <ul className="space-y-1">
            {details.map((detail, index) => (
              <li key={index} className="text-sm text-muted-foreground flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>{detail}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
